import ServiceIconOne from '../../assets/icons/serviceIconOne'
import ServiceIconTwo from '../../assets/icons/serviceIconTwo'
import ServiceIconThree from '../../assets/icons/serviceIconThree'
import ServiceIconFour from '../../assets/icons/serviceIconFour'
import ServiceIconFive from '../../assets/icons/serviceIconFive'
import ServiceIconSix from '../../assets/icons/serviceIconSix'

export const  servicesDataTwo = [
    {
        id: 1,
        service_name: "Endpoint Security",
        service_details: "Tailored Services for a Secure Tomorrow.",
        link: "/service-details",
        src: ServiceIconOne 
    },
    {
        id: 2,
        service_name: "Cloud Security",
        service_details: "Tailored Services for a Secure Tomorrow.",
        link: "/service-details",
        src: ServiceIconTwo 
    },
    {
        id: 3,
        service_name: "Security Consulting",
        service_details: "Our Robust Cybersecurity Service Suite.",
        link: "/service-details",
        src: ServiceIconThree 
    },
    {
        id: 4,
        service_name: "Network Security",
        service_details: "Elevate Your Protection with Our Cyber Services.",
        link: "/service-details",
        src: ServiceIconFour 
    },
    {
        id: 5,
        service_name: "Application Security",
        service_details: "Your Trusted Partner in Digital Security",
        link: "/service-details",
        src: ServiceIconFive 
    },
    {
        id: 6,
        service_name: "Security Awareness",
        service_details: "Unveiling Our Cybersecurity Service Arsenal.",
        link: "/service-details",
        src: ServiceIconSix 
    },

]